interface IconProps {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export const GPayIcon = ({
  size = 45,
  width,
  height,
  fill = "none",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size * (18 / 45)}
      viewBox="0 0 45 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.366 4.94305C32.5824 4.94305 33.5224 5.27482 34.2412 5.93837C34.96 6.60182 35.2917 7.48652 35.2917 8.59237V13.9004H33.7435V12.6841H33.6882C33.0247 13.6794 32.0847 14.177 30.9789 14.177C30.0389 14.177 29.2095 13.9005 28.546 13.3476C27.9378 12.7947 27.5507 12.0206 27.5507 11.1912C27.5507 10.3065 27.8826 9.58769 28.546 9.03476C29.2095 8.48184 30.1495 8.26069 31.2553 8.26069C32.2506 8.26069 33.0247 8.42662 33.6329 8.81361V8.42662C33.6329 7.91051 33.4403 7.39448 33.0549 7.05822L32.9693 6.98899C32.527 6.60191 31.9741 6.38076 31.366 6.38076C30.426 6.38076 29.7072 6.76784 29.2095 7.54192L27.772 6.65705C28.6566 5.49589 29.8177 4.94305 31.366 4.94305ZM23.5697 1.18311C24.5618 1.18311 25.5047 1.52836 26.2585 2.1722L26.3896 2.28887C27.1637 2.95241 27.5507 3.94773 27.5507 4.99827C27.5507 6.04881 27.1637 6.98882 26.3896 7.70759C25.6155 8.42644 24.6756 8.81344 23.5697 8.81344L20.9157 8.75813V13.9004H19.2568V1.18311H23.5697ZM31.587 9.5876C30.9236 9.5876 30.3706 9.75345 29.9283 10.0852C29.486 10.3617 29.2648 10.7487 29.2648 11.2463C29.2648 11.6887 29.486 12.0757 29.8177 12.2969C30.2048 12.5734 30.6471 12.7392 31.0895 12.7392C31.7087 12.7392 32.328 12.4984 32.8124 12.0617L32.9141 11.9651C33.467 11.4675 33.7435 10.8593 33.7435 10.1958C33.2459 9.80876 32.527 9.58752 31.5871 9.58752M23.6804 2.73117H20.9158V7.15484H23.6804C24.2886 7.15484 24.8968 6.93368 25.2839 6.49138C26.1685 5.66199 26.1685 4.27968 25.3392 3.4502L25.2839 3.39489C24.8415 2.95259 24.2886 2.67612 23.6803 2.73143M44.2491 5.21951L38.7751 17.7709H37.1164L39.1621 13.4029L35.5681 5.27482H37.3375L39.9362 11.5228H39.9915L42.535 5.27482H44.2491V5.21951Z"
        fill="#5F6368"
      />
      <path
        d="M14.3355 7.65251C14.3355 7.1549 14.2802 6.65728 14.2249 6.15967H7.31348V8.9796H11.2392C11.0733 9.86421 10.5757 10.6936 9.80164 11.1913V13.0159H12.1792C13.5615 11.7442 14.3356 9.86421 14.3356 7.6526"
        fill="#4285F4"
      />
      <path
        d="M7.31355 14.7852C9.30401 14.7852 10.9628 14.1217 12.1793 13.0158L9.80171 11.1912C9.13816 11.6335 8.30878 11.91 7.31355 11.91C5.43353 11.91 3.77476 10.6383 3.22183 8.8689H0.789062V10.7488C2.06076 13.237 4.54892 14.7852 7.31355 14.7852Z"
        fill="#34A853"
      />
      <path
        d="M3.22171 8.86905C2.89003 7.98436 2.89003 6.98913 3.22171 6.04912V4.16919H0.788947C-0.26168 6.21505 -0.26168 8.6479 0.788947 10.749L3.22171 8.86905Z"
        fill="#FBBC04"
      />
      <path
        d="M7.3135 3.06327C8.36404 3.06327 9.35927 3.45035 10.1334 4.16912L12.2345 2.06804C10.9074 0.851571 9.13812 0.132803 7.36872 0.188026C4.6041 0.188026 2.06071 1.73627 0.844238 4.22443L3.27709 6.10436C3.77471 4.33497 5.43348 3.06327 7.3135 3.06327Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GPayIcon;
